"use strict";
import {http} from '../../../core';
const RequestService = http.create();

export default {
    // 全部未完成工单
    getNocompletedList:function (params) {
        return RequestService.get("user_statistics/all_order/not_completed",params);
    },
    // 邮件通知
    sendmsg:function (params) {
        return RequestService.post('user_statistics/all_order/not_completed_send_msg',params)
    },
   
   
}
